import React from 'react';
import { useQuery } from '@tanstack/react-query';
import useApiClient from '../../hooks/useApiClient';
import TreeSelectDropdown from '../dropdowns/treeSelectDropdown';
import { QUERY_OPTIONS_LOAD_ONCE } from '../../apiUtils';
import { TreeSelectDropdownSmartWrapperProps } from '../dropdowns/types';
import { RealAssetTreeNode } from '../../apiClient';
import { renderNodeIconAndName } from './util';

export const RealAssetTreeDropdown: React.FC<TreeSelectDropdownSmartWrapperProps<RealAssetTreeNode>> = (props) => {
    const api = useApiClient();

    const { data: realAssetTree, isLoading: assetsAreLoading } = useQuery({
        queryKey: ["realAssetTree"],
        queryFn: () => api.dataAccess.listRealAssetTree(),
        ...QUERY_OPTIONS_LOAD_ONCE,
    });

    return (
        <TreeSelectDropdown
            label={props.label || "Real Asset"}
            options={realAssetTree?.tree || []}
            selectedIds={props.selectedIds || []}
            onOptionToggle={props.onOptionToggle}
            isLoading={assetsAreLoading}
            labelClassName={props.labelClassName}
            dropdownClassName={props.dropdownClassName}
            enableSearch={props.enableSearch}
            initiallyExpanded={props.initiallyExpanded}
            showHideUnselectedToggle={props.showHideUnselectedToggle || false}
            renderNode={(node: any) => renderNodeIconAndName(node, (node: any) => node.type)}

        />
    );
};

export default RealAssetTreeDropdown;